import { SidebarHeader } from '@ibsys/kit';
import { useTheme } from '@/app/providers/ThemeProvider';
import { FC } from 'react';
import { useIsSidebarCollapsed } from '@/shared/hooks';
import { cn } from '@/shared/lib';
import DOMPurify from 'dompurify';

type Props = {
  className?: string;
};

/** Проверяет, является ли значение inline SVG-разметкой (а не URL или data URI) */
const isInlineSvg = (value: string) => value.trimStart().startsWith('<');

export const AppSidebarHeader: FC<Props> = ({ className }) => {
  const { logoSvg, favicon } = useTheme();
  const isCollapsed = useIsSidebarCollapsed();

  const headerClassName = cn(
    'flex flex-col bg-sidebar border-b border-sidebar-border justify-center',
    isCollapsed && 'items-center',
    className,
  );

  // Фавикон задан как раз под узкую колонку; пока он не задан, шапка остаётся на логотипе.
  if (isCollapsed && favicon) {
    return (
      <SidebarHeader className={headerClassName}>
        <img src={favicon} alt="" className="size-8 object-contain" />
      </SidebarHeader>
    );
  }

  if (!logoSvg) {
    return <SidebarHeader className={headerClassName} />;
  }

  if (isInlineSvg(logoSvg)) {
    const cleanSvg = DOMPurify.sanitize(logoSvg, { USE_PROFILES: { svg: true } });

    return (
      <SidebarHeader className={headerClassName}>
        <div dangerouslySetInnerHTML={{ __html: cleanSvg }} />
      </SidebarHeader>
    );
  }

  return (
    <SidebarHeader className={headerClassName}>
      <img src={logoSvg} alt="" className="h-8 w-auto object-contain object-left" />
    </SidebarHeader>
  );
};
